<template>
    <div>
        <!-- 预留实例购买清单 -->
        <div>
            <Row :gutter="10" style="margin-bottom: 10px;">
                <Col span="24">
                    <Card>
                        <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t('ApprovalTask.reservedInstancePurchaseList')}}</p>
                        <!-- 关联案例ID -->
                        <FormItem :label="$t('ApprovalTask.associatedCaseID')" :label-width="90">
                            <Row>
                                <Col span="24">{{ticketEntityId}}</Col>
                            </Row>
                        </FormItem>
                        <!-- 匹配类型 -->
                        <FormItem :label="$t('ApprovalTask.matchType')" :label-width="90">
                            <Row>
                                <Col span="24">{{reservedInstanceSaveType}}</Col>
                            </Row>
                        </FormItem>
                        <!-- 预留实例购买清单 -->
                        <FormItem :label="$t('ApprovalTask.purchaseList')" :label-width="90">
                            <Table :no-data-text="$t('common.noData')" :columns="columns" :loading="reservedLoading" :data="dataList" style="width:100%;"></Table>
                        </FormItem>
                        <!-- 提示 -->
                        <FormItem label="" :label-width="90" v-show="showTip">
                            <Row style="line-height:17px;">
                                <Col span="24">
                                    <Checkbox v-model="disclaimer" @on-change="changeDisclaimer">{{$t('ApprovalTask.tip')}}</Checkbox>
                                </Col>
                            </Row>
                        </FormItem>
                    </Card> 
                </Col>
            </Row>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'ReservedInstance',
        props: ['reservedInstanceListForm'],
        data() {
            return {
                showTip:false,
                disclaimer: true,// 提示
                reservedLoading:false,
                matchType:parseInt(this.$route.query.customizeReservedInstanceSaveType),
            	ticketEntityId: '',
            	reservedInstanceSaveType:'',//预留实例购买
                columns: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: this.$t('ApprovalTask.accountName'),
                    key: 'accountName',
                    minWidth: 150
                },
                {
                    title: this.$t('ApprovalTask.accountId'),
                    key: 'accountIdStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.region'),
                    key: 'region',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.instanceCount'),
                    key: 'instanceCount',
                    minWidth: 100
                },
                {
                    title: this.$t('ApprovalTask.normalizationFactor'),
                    key: 'normalizationFactor',
                    minWidth: 100
                },
                {
                    title: this.$t('ApprovalTask.actualPurchasedQuantity'),
                    key:'actualPurchasedQuantity',
                    minWidth: 110
                },
                {
                    title: this.$t('ApprovalTask.instanceType'),
                    key: 'instanceType',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.price'),
                    key: 'priceDescription',
                    minWidth: 180,
                },
                {
                    title: this.$t('ApprovalTask.productDescription'),
                    key: 'productDescription',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.instanceTenancy'),
                    key: 'instanceTenancyStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.offeringType'),
                    key: 'offeringTypeStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.offeringClass'),
                    key: 'offeringClassStr',
                    minWidth: 140
                },
                {
                    title: this.$t('ApprovalTask.endDate'),
                    key: 'endDateStr',
                    minWidth: 140,
                },
                {
                    title: this.$t('ApprovalTask.duration'),
                    key: 'durationStr',
                    minWidth: 140
                }],//预留实例购买清单
                dataList:[],
                newDataList:[]
            }
        },
        mounted: function () {
            this.approvalReview();
        },
        methods: {
            /**********************提示******************************/
            // 切换提示
            changeDisclaimer:function(){
                if(this.disclaimer==true){
                    this.reservedInstanceListForm.isDisable = false; 
                }else if(this.disclaimer==false){
                    this.reservedInstanceListForm.isDisable = true;
                }
            },
            /**********************预留实例购买******************************/
            // 查看预留实例购买详情
            approvalReview:function(){
                this.reservedLoading=true;
                // 审批
                this.$api.processTask.approvalReview({
                    "processTaskId":this.$route.query.id,
                    "customizeReservedInstanceSaveType":this.matchType
                })
                .then(res => {
                    this.reservedLoading=false;
                    // 关联案例ID
                    this.ticketEntityId=res.data.purchaseReservedInstance.ticketEntityId;
                    // 匹配类型
                    this.reservedInstanceSaveType=res.data.purchaseReservedInstance.previousNodeReservedInstanceSaveType==0 ? "原始数据":"标准化数量";
                    // 预留实例购买清单
                    this.dataList=res.data.purchaseReservedInstance.waitingForPurchaseReservedInstanceDTOs;
                    for(var i=0;i<this.dataList.length;i++){
                        /*****************选中内容********************/
                        // 禁止点击
                        this.dataList[i]._disabled = true;
                        // 选中
                        this.dataList[i]._checked = this.dataList[i].selected;
                        if(this.dataList[i]._checked = this.dataList[i].selected){
                            var tableReservedCopy={
                                "accountName": this.dataList[i].accountName,
                                "accountIdStr": this.dataList[i].accountIdStr,
                                "instanceTenancyStr": this.dataList[i].instanceTenancyStr,
                                "offeringTypeStr": this.dataList[i].offeringTypeStr,
                                "offeringClassStr": this.dataList[i].offeringClassStr,
                                "durationStr": this.dataList[i].durationStr,
                                "linuxServerFlag": this.dataList[i].linuxServerFlag,
                                "accountId": this.dataList[i].accountId,
                                "duration": this.dataList[i].duration,
                                "instanceTenancy": this.dataList[i].instanceTenancy,
                                "instanceType": this.dataList[i].instanceType,
                                "offeringClass": this.dataList[i].offeringClass,
                                "offeringType": this.dataList[i].offeringType,
                                "productDescription": this.dataList[i].productDescription,
                                "region": this.dataList[i].region,
                                "ticketId": this.dataList[i].ticketId,
                                "scope":this.dataList[i].scope,
                                "priceDescription":this.dataList[i].priceDescription,
                                "instanceCount":this.dataList[i].instanceCount,
                                "normalizationFactor":this.dataList[i].normalizationFactor,
                                "actualPurchasedQuantity":this.dataList[i].actualPurchasedQuantity,
                                "endDateStr":this.dataList[i].endDateStr
                            };
                            if(this.matchType==0||(this.matchType==1&&this.dataList[i].linuxServerFlag==false)){
                                tableReservedCopy.id=this.dataList[i].id;
                            }
                            this.newDataList.push(tableReservedCopy);
                        }
                    }

                    /*****************提示********************/
                    // 接口返回数组与最后修改数组不一致显示 提示
                    for(var i=0;i<this.newDataList.length;i++){
                        // 当匹配类型为"原始数据"或者linuxServerFlag为"false" 显示"数量"字段 
                        if(this.matchType==0||this.newDataList[i].linuxServerFlag==false){
                            if((this.newDataList[i].actualPurchasedQuantity!=this.newDataList[i].instanceCount)||(this.newDataList.length!=this.dataList.length)){
                                // 显示提示
                                this.showTip=true;
                                break;
                            }else{
                                // 隐藏提示
                                this.showTip=false;
                            }
                        }
                        // 当匹配类型为"标准化因子"且linuxServerFlag为"true" 显示"标准化因子"字段 
                        else if(this.matchType==1&&this.newDataList[i].linuxServerFlag==true){
                            if((this.newDataList[i].actualPurchasedQuantity!=this.newDataList[i].normalizationFactor)||(this.newDataList.length!=this.dataList.length)){ 
                                // 显示提示
                                this.showTip=true;
                                break;
                            }else{
                                // 隐藏提示
                                this.showTip=false;
                            }
                        }
                    }
                })
            }
        }
    }
</script>

<style>
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>




// WEBPACK FOOTER //
// src/components/approval_task/approval_type/reserved_instance/ReservedInstanceList.vue